module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 12 21",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#facebook",
      toString: function () {
        return this.url;
      }
    }